import { defineTokens } from '@chakra-ui/react'
// Adapted from davinci-elections apps/web/src/theme/tokens.ts @ 6e23f58
import { colors } from './colors'

const sidebarWidth = '350px'

const fonts = defineTokens.fonts({
  body: { value: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif` },
  heading: { value: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif` },
  mono: { value: `'Menlo', monospace` },
})

// vocdoni-app reads light: headings and buttons at 400, hierarchy by size. Its tokens shift one step lighter
// (normal 300, bold 400); here the floor stays at 400 (spec Goal 7: "weights >= 400"), so `normal` and `medium` are
// both the regular cut, `bold` is Inter 500 for an emphasised line and `bolder`/`semibold` 600 for dialog titles.
const fontWeights = defineTokens.fontWeights({
  normal: { value: '400' },
  medium: { value: '400' },
  semibold: { value: '600' },
  bold: { value: '500' },
  bolder: { value: '600' },
})

// vocdoni-app type scale (Chakra's: md 16, lg 18, xl 20, 2xl 24, 3xl 30, 4xl 36). On the member pages nothing is
// smaller than 16 px (ruling R94), so `xs` and `sm` are 16 px here; the admin area restores vocdoni-app's 12/14 px
// through `html[data-area='admin']` (see system.ts).
const fontSizes = defineTokens.fontSizes({
  xs: { value: '1rem' },
  sm: { value: '1rem' },
  md: { value: '1rem' },
})

const radii = defineTokens.radii({
  none: { value: '0rem' },
  xxs: { value: '2px' },
  xs: { value: '4px' },
  sm: { value: '6px' },
  md: { value: '8px' },
  lg: { value: '10px' },
  xl: { value: '12px' },
  '2xl': { value: '16px' },
  '3xl': { value: '20px' },
  '4xl': { value: '24px' },
  full: { value: '9999px' },
})

const spacing = defineTokens.spacing({
  sidebar: { value: sidebarWidth },
})

const sizes = defineTokens.sizes({
  'cookies-consent': { value: '720px' },
  'dashboard-menu': {
    default: { value: '255px' },
    reduced: { value: '48px' },
  },
  'max-window-width': { value: '2560px' },
  'max-content-width': { value: '1200px' },
  navbar: { value: '1920px' },
  sidebar: { value: sidebarWidth },
  'user-profile': { value: '280px' },
  voting: {
    sidebar: { value: '320px' },
    contents: {
      min: { value: 'calc(640px + var(--chakra-sizes-voting-sidebar))' },
      max: { value: '1560px' },
    },
  },
})

const zIndex = defineTokens.zIndex({
  background: { value: 0 },
  contents: { value: 1 },
  sidebar: { value: 2 },
  topbar: { value: 3 },
  modal: { value: 1400 },
  hovering: { value: 1500 },
  top: { value: 9999 },
})

const tokens = defineTokens({
  colors,
  radii,
  sizes,
  spacing,
  zIndex,
  fonts,
  fontWeights,
  fontSizes,
})

export default tokens
